"use strict";import{css as r}from"@spectrum-web-components/base";const o=r`
:host{--spectrum-color-slider-handle-margin-block:var(
--spectrum-component-top-to-text-75
);--spectrum-color-slider-border-color-rgba:rgba(var(--spectrum-gray-900-rgb),var(--spectrum-color-slider-border-opacity));--spectrum-color-slider-checkerboard-size:var(
--spectrum-opacity-checkerboard-square-size
);--spectrum-color-slider-checkerboard-dark-color:var(
--spectrum-opacity-checkerboard-square-dark
);--spectrum-color-slider-checkerboard-light-color:var(
--spectrum-opacity-checkerboard-square-light
);--mod-colorhandle-hitarea-border-radius:var(
--mod-color-slider-handle-hitarea-border-radius,0px
)}@media (forced-colors:active){:host{--highcontrast-color-slider-border-color:CanvasText;--highcontrast-color-slider-border-color-disabled:GrayText;--highcontrast-color-slider-background-color-disabled:Canvas;forced-color-adjust:none}}:host{block-size:var(
--mod-color-slider-control-track-width,var(--spectrum-color-control-track-width)
);cursor:default;display:block;inline-size:var(
--mod-color-slider-length,var(--spectrum-color-slider-length)
);min-inline-size:var(
--mod-color-slider-minimum-length,var(--spectrum-color-slider-minimum-length)
);position:relative;-webkit-user-select:none;user-select:none}:host([focused]){z-index:2}:host([disabled]){pointer-events:none}:host([disabled]) .gradient{display:none}:host([vertical]){block-size:var(
--mod-color-slider-vertical-height,var(--mod-color-slider-length,var(--spectrum-color-slider-length))
);display:inline-block;inline-size:var(
--mod-color-slider-vertical-control-track-width,var(
--mod-color-slider-control-track-height,var(--spectrum-color-control-track-width)
)
);min-block-size:var(
--mod-color-slider-vertical-minimum-height,var(
--mod-color-slider-minimum-length,var(--spectrum-color-slider-minimum-length)
)
);min-inline-size:0}:host([vertical]) .handle{inset-block-start:0;inset-inline-start:50%}.handle{inset-block-start:50%;inset-inline-start:0}.checkerboard{--spectrum-color-slider-border-color-local:var(
--highcontrast-color-slider-border-color,var(
--mod-color-slider-border-color,var(--spectrum-color-slider-border-color-rgba)
)
)}.checkerboard:before{border-radius:var(
--mod-color-slider-border-rounding,var(--spectrum-color-slider-border-rounding)
);box-shadow:inset 0 0 0 var(
--mod-color-slider-border-width,var(--spectrum-color-slider-border-width)
) var(--spectrum-color-slider-border-color-local);content:"";inset:0;position:absolute;z-index:1}:host([disabled]) .checkerboard{--spectrum-color-slider-border-color-local:var(
--highcontrast-color-slider-border-color-disabled,var(
--mod-color-slider-border-color-disabled,var(--spectrum-disabled-background-color)
)
);background:var(
--highcontrast-color-slider-background-color-disabled,var(
--mod-color-slider-background-color-disabled,var(--spectrum-disabled-background-color)
)
)}.checkerboard,.gradient{block-size:100%;border-radius:var(
--mod-color-slider-border-rounding,var(--spectrum-color-slider-border-rounding)
);inline-size:100%}:host([dir=rtl]) .gradient{transform:scaleX(-1)}.slider{block-size:100%;inline-size:100%;inset-block-start:0;inset-inline-start:0;margin:0;opacity:0;pointer-events:none;position:absolute;z-index:0}:host{--sp-color-slider-gradient-fallback:red 0%,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red 100%;touch-action:none}:host([vertical]) .handle{inset-block-end:0;inset-block-start:unset}:host([vertical]) .slider{appearance:slider-vertical}:host(:focus){outline:none}.gradient{overflow:hidden}::slotted(*){height:100%;width:100%}
`;export default o;
//# sourceMappingURL=color-slider.css.js.map
